import React from "react";
import MediumPage from "../../../../layout/page/MediumPage";
import Panel from "../../../../layout/panel/Panel";
import withUser from "../../../auth/HOC/withUser";
import commons from "../commons";
import Blocks from "./Blocks";
import Welcome from "../../../home/Welcome";

function BlockList({ user }) {
  return (
    <MediumPage header={<Welcome />} containerStyle={{ maxWidth: "100%" }}>
      <h1 style={{ color: "#FFF" }}>Vos {commons.plural}</h1>
      <p style={{ color: "#FFF" }}>Liste de vos {commons.plural}</p>
      <Panel>
        <Blocks showDefaultMenu={false} showFilter={true} id={user.id} />
      </Panel>
    </MediumPage>
  );
}

export default withUser(BlockList);
